import { memo, useCallback, useContext } from 'react'

import { TtsItemContext } from '../../contextApi'
import * as Styled from './styled'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import DownloadIcon from 'assets/svgr-icons/Download.svg'
import { TextWithIconTooltip } from 'common-components'
import { downloadMedia } from 'utils'
import { toSafeFileName } from 'utils/fileName'
import {
  useGetTtsItemFilePath,
  useGetTtsItemGeneratedState
} from 'containers/SubSidebar/TtsContent/hooks'

const TtsDownloadButton: React.FC = () => {
  const { id, text } = useContext(TtsItemContext)
  const isGenerated = useGetTtsItemGeneratedState(id)
  const filePath = useGetTtsItemFilePath(id)
  const isDisabled = !isGenerated || !filePath

  const handleDownload = useCallback(() => {
    if (isDisabled) {
      return
    }
    downloadMedia({
      filePath,
      fileName: toSafeFileName(text, 'tts-audio')
    })
  }, [isDisabled, filePath, text])

  if (!text.trim()) {
    return null
  }

  return (
    <Styled.TtsDownloadButtonWrapper $isDisabled={isDisabled}>
      <TextWithIconTooltip
        iconProps={{
          icon: <DownloadIcon />,
          size: 'small',
          color: 'secondarySemiDark'
        }}
        tooltipText={
          isDisabled
            ? translate(T.TTS_DOWNLOAD_DISABLED_TOOLTIP)
            : translate(T.TTS_DOWNLOAD_ACTIVE_TOOLTIP)
        }
        tooltipPosition="top"
        onClick={handleDownload}
        showMobileTooltip={isDisabled}
      />
    </Styled.TtsDownloadButtonWrapper>
  )
}

export default memo(TtsDownloadButton)
